import { HeroSectionProps } from "../../model";

export default function HeroSection({ title, ...props }: HeroSectionProps) {
	return (
		<section {...props} class="flex flex-col bg#p py-220px justify-center items-center text-white">
			<p class="w-1007px text-center text-76px font-bold leading-84px ">{title}</p>
		</section>
	);
}
